import React, { useState, useEffect } from "react";
import { Pencil, X, Check, ChevronRight } from "lucide-react";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import { BASE_URL } from "utils/constant";
import { useAlert } from "components/UI_components/Alert";
import { useNavigate, useNavigation } from "react-router-dom";
const Skeleton = ({ className = "" }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

const SiteDetails = ({ userPermissions }) => {
  const { addAlert } = useAlert();
  // Normalize and map state names from the PIN API to your <states> array
  const norm = (s = "") =>
    s.toLowerCase().replace(/&/g, "and").replace(/\s+/g, " ").trim();

  // Common aliases seen in PIN APIs
  const STATE_ALIAS_MAP = {
    "nct of delhi": "Delhi",
    "delhi (nct)": "Delhi",
    "jammu & kashmir": "Jammu and Kashmir",
    "andaman & nicobar islands": "Andaman and Nicobar Islands",
    "dadra & nagar haveli and daman & diu":
      "Dadra and Nagar Haveli and Daman and Diu",
    pondicherry: "Puducherry",
    uttaranchal: "Uttarakhand",
  };

  const mapToOfficialState = (rawState, statesList) => {
    if (!rawState) return "";
    const n = norm(rawState);
    const alias = STATE_ALIAS_MAP[n];
    const candidate = alias || rawState;

    // Exact (normalized) match against the options you already fetched
    const exact = statesList.find((s) => norm(s) === norm(candidate));
    if (exact) return exact;

    // Fallback: loose contains check
    const loose = statesList.find(
      (s) => norm(s).includes(n) || n.includes(norm(s))
    );
    return loose || candidate; // fallback to raw if no match found
  };

  const aler = useAlert();
  const navigate = useNavigate();
  const [siteData, setSiteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [adminBodies, setAdminBodies] = useState([]);
  const [editPermsission, setEditPermission] = useState(false);
  const [editMode, setEditMode] = useState({
    site_name: false,
    site_area: false,
    local_admin_body_name: false,
    address: false,
    site_catagory_id: false,
    start_date: false,
    constructionStatus: false,
    description: false,
  });

  const [editModalOpen, setEditModalOpen] = useState(false);

  // Delete confirmation modal state
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [formData, setFormData] = useState({
    site_name: "",
    site_area: "",
    site_unit: "m_sq",
    local_admin_body_name: "",
    local_admin_body_id: "",
    address: "",
    site_catagory_id: "",
    start_date: "",
    constructionStatus: "",
    description: "",
    esrimated_cost: "",
    state: "",
    city: "",
    pincode: "",
  });
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await axios.post(
          "https://countriesnow.space/api/v0.1/countries/states",
          { country: "India" }
        );
        setStates(res.data.data.states.map((s) => s.name));
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
    };
    fetchStates();
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      if (!formData.state) return;
      try {
        const res = await axios.post(
          "https://countriesnow.space/api/v0.1/countries/state/cities",
          {
            country: "India",
            state: formData.state,
          }
        );
        console.log("Cities", res.data);
        setCities(res.data.data);
      } catch (err) {
        console.error("Failed to fetch cities:", err);
      }
    };
    fetchCities();
  }, [formData.state]);

  const constructionStatusOptions = [
    "Completed",
    "Upcoming",
    "Halted",
    "Ongoing",
  ];

  const LoadingSkeleton = () => (
    <div className="w-full mx-auto p-4">
      {/* Hero Image Skeleton */}
      <Skeleton className="h-48 w-full rounded-lg mb-4" />

      {/* Header Skeleton */}
      <div className="flex justify-between items-center mb-4">
        <Skeleton className="h-8 w-40" />
        <Skeleton className="h-6 w-20" />
      </div>

      {/* Content Skeleton */}
      <div className="bg-white rounded-lg">
        {[1, 2, 3, 4, 5, 6, 7].map((index) => (
          <div key={index} className="border-b border-gray-200 py-4">
            <div className="flex justify-between items-center mb-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <Skeleton className="h-6 w-3/4" />
          </div>
        ))}
      </div>
    </div>
  );

  const fetchAdminBodies = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await axios.get(
        `${BASE_URL}/sites/get-all-localadminbody/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAdminBodies(response.data.data);
    } catch (error) {
      console.error("Error fetching admin bodies:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await axios.get(
        `${BASE_URL}/sites/get-all-sitecatagory/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCategories(response.data.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSiteDetails = async () => {
    try {
      const siteId = localStorage.getItem("site");
      const token = localStorage.getItem("access");
      const response = await axios.get(
        `${BASE_URL}/sites/get-a-sites/${siteId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSiteData(response.data.data);
      if (response?.data?.data) {
        localStorage.setItem("siteData", JSON.stringify(response.data.data));
      }

      const matchedAdminBody = adminBodies.find(
        (ab) => ab.id === response.data.data.local_admin_body_id
      );

      setFormData({
        site_name: response.data.data.site_name,
        site_area: response.data.data.site_area,
        site_unit: response.data.data.uom,
        local_admin_body_name:
          matchedAdminBody?.admin_body_type ||
          response.data.data.local_admin_body_name,

        local_admin_body_id: response.data.data.local_admin_body_id,
        address: response.data.data.address,
        site_catagory_id: response.data.data.site_catagory_id,
        start_date: response.data.data.start_date,
        constructionStatus: response.data.data.constructionStatus || "Ongoing",
        description: response.data.data.description || "",
        esrimated_cost: response.data.data.esrimated_cost || "",
        city: response.data.data.city || "",
        state: response.data.data.state || "",
        pincode: response.data.data.pincode || "",
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching site details:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSiteDetails();
    fetchCategories();
    fetchAdminBodies();
  }, []);
  useEffect(() => {
    if (adminBodies.length > 0) {
      fetchSiteDetails();
    }
  }, [adminBodies]);

  const handleUpdate = async (field, value = null) => {
    try {
      const siteId = localStorage.getItem("site");
      const token = localStorage.getItem("access");
      let updateData = {};

      switch (field) {
        case "site_name":
          updateData = { site_name: formData.site_name };
          break;
        case "site_area":
          updateData = {
            site_area: parseFloat(formData.site_area),
            uom: formData.site_unit,
          };
          break;
        case "local_admin_body_name":
          updateData = {
            local_admin_body_name: formData.local_admin_body_name,
            local_admin_body_id: formData.local_admin_body_id,
          };
          break;
        case "site_catagory_id":
          updateData = { site_catagory_id: formData.site_catagory_id };
          break;
        case "constructionStatus":
          updateData = { constructionStatus: formData.constructionStatus };
          break;
        case "description":
          updateData = { description: formData.description };
          break;
        case "image_file":
          // Special handling for image file
          // The second argument to handleUpdate should be the file object
          // We need to adjust the function signature or arguments usage
          // But here I'm assuming I passed the file as the second argument to handleUpdate
          // Let's fix the function signature in the next step or assume arguments[1]
          break;

        default:
          updateData = { [field]: formData[field] };
      }

      let payload = updateData;
      let headers = {
        Authorization: `Bearer ${token}`,
      };

      if (field === "image_file") {
        const file = value;
        const formDataObj = new FormData();
        formDataObj.append("image_file", file);
        payload = formDataObj;
        headers["Content-Type"] = "multipart/form-data";
      }

      await axios.patch(`${BASE_URL}/sites/update-sites/${siteId}/`, payload, {
        headers: headers,
      });

      setEditMode({ ...editMode, [field]: false });
      await fetchSiteDetails();
    } catch (error) {
      console.error("Error updating site details:", error);
    }
  };

  const handlePinChange = async (pin) => {
    if (!/^\d{6}$/.test(pin)) return; // guard
    const options = {
      method: "GET",
      url: "https://indian-pincode-2024.p.rapidapi.com/pincode",
      params: { pincode: pin },
      headers: {
        "x-rapidapi-key": "f01ac027f0msh4661f5f3d5db7e1p1da2e3jsn8ce0dcc2d48e",
        "x-rapidapi-host": "indian-pincode-2024.p.rapidapi.com",
      },
    };
    try {
      const res = await axios.request(options);
      const api = res?.data?.data || {};

      // Prefer district_name for "city", then division_name, then office_name
      const rawCity =
        api.district_name ||
        api.division_name ||
        api.office_name ||
        api.block_name ||
        "";

      // Map the API's state into your <states> list so the select shows the correct value
      const officialState = mapToOfficialState(
        api.state_name || api.state,
        states
      );

      setFormData((prev) => ({
        ...prev,
        state: officialState,
        city: rawCity,
      }));
    } catch (error) {
      console.error("Error fetching pincode details:", error);
    }
  };

  // Delete site handler
  const handleDeleteSite = async () => {
    try {
      setDeleting(true);
      const siteId = siteData?.id || localStorage.getItem("site");
      const token = localStorage.getItem("access");
      if (!siteId) {
        addAlert("Unable to determine site id", "error");
        setDeleting(false);
        return;
      }

      await axios.delete(`${BASE_URL}/sites/delete-sites/${siteId}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // cleanup and navigate
      localStorage.removeItem("site");
      localStorage.removeItem("siteData");
      addAlert("Site deleted successfully", "success");
      // small delay to allow user to see alert
      setTimeout(() => {
        navigate("/dashboard/projects");
      }, 150);
    } catch (err) {
      console.error("Error deleting site:", err);
      addAlert("Failed to delete site", "error");
      setDeleting(false);
    }
  };

  useEffect(() => {
    if (userPermissions.is_admin) {
      setEditPermission(true);
    }
  }, [userPermissions]);

  const totalFields = Object.keys(formData).length;
  const incompleteFields = Object.values(formData).filter(
    (val) => val === "" || val === null || val === undefined
  ).length;
  const completionPercent = Math.round(
    ((totalFields - incompleteFields) / totalFields) * 100
  );

  return loading ? (
    <LoadingSkeleton />
  ) : (
    <div
      className="w-full mx-auto p-4"
      style={{
        height: "90vh",
        overflowY: "scroll",
      }}
    >
      {/* Top Project Details Header */}
      <div className="mb-6">
        <div className="flex items-center gap-2 text-gray-700 text-sm mb-2">
          <button onClick={() => window.history.back()} className="text-lg">
            ←
          </button>
          <span className="font-semibold text-base">Project Details</span>
        </div>

        {/* Project Title + Status */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            {!editMode.site_name ? (
              <div className="flex items-center gap-2">
                <h2 className="text-2xl font-semibold">
                  {siteData?.site_name || "Loading..."}
                </h2>
                <button
                  disabled={!editPermsission}
                  onClick={() => setEditMode({ ...editMode, site_name: true })}
                  className="text-gray-400"
                >
                  <Pencil size={18} />
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={formData.site_name}
                  onChange={(e) =>
                    setFormData({ ...formData, site_name: e.target.value })
                  }
                  className="p-2 rounded border border-gray-300"
                />
                <button
                  onClick={() => setEditMode({ ...editMode, site_name: false })}
                >
                  <X size={18} className="text-gray-500" />
                </button>
                <button onClick={() => handleUpdate("site_name")}>
                  <Check size={18} className="text-purple-600" />
                </button>
              </div>
            )}

            {editMode.constructionStatus ? (
              <select
                value={formData.constructionStatus}
                onChange={(e) => {
                  const newStatus = e.target.value;
                  setFormData((prev) => ({
                    ...prev,
                    constructionStatus: newStatus,
                  }));
                }}
                onBlur={() => {
                  handleUpdate("constructionStatus");
                  setEditMode((prev) => ({
                    ...prev,
                    constructionStatus: false,
                  }));
                }}
                className="ml-4 px-3 py-1 text-sm rounded-full border border-gray-300 focus:outline-none"
              >
                {["Ongoing", "Halted", "Upcoming", "Completed"].map(
                  (status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  )
                )}
              </select>
            ) : (
              <span
                onClick={() =>
                  setEditMode((prev) => ({ ...prev, constructionStatus: true }))
                }
                className={`ml-4 px-3 py-1 text-sm rounded-full cursor-pointer ${formData.constructionStatus === "Completed"
                  ? "bg-green-100 text-green-800"
                  : formData.constructionStatus === "Halted"
                    ? "bg-red-100 text-red-800"
                    : formData.constructionStatus === "Upcoming"
                      ? "bg-yellow-100 text-yellow-800"
                      : "bg-blue-100 text-blue-800"
                  }`}
              >
                {formData.constructionStatus || "Unknown Status"}
              </span>
            )}
          </div>
          {editPermsission && (
            <button
              disabled={!editPermsission}
              onClick={() => setDeleteConfirmOpen(true)}
              className="px-4 py-2 bg-red-50 text-red-600 hover:bg-red-100 hover:text-red-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg flex items-center gap-2 transition-all duration-200 border border-red-200 hover:border-red-300 shadow-sm hover:shadow"
              title="Delete this project"
            >
              <MdDelete size={18} />
              <span className="text-sm font-medium">Delete Project</span>
            </button>
          )}
        </div>

        {/* Completion Box */}
        {completionPercent < 100 && (
          <div className="border border-purple-200 rounded-xl p-4 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
            {/* Completion Info Section */}
            <div>
              <p className="text-sm text-gray-600 mb-3">Details completion</p>
              <div className="flex items-center gap-3">
                <div className="text-purple-700 font-semibold text-lg">
                  {completionPercent}% Complete
                </div>
                <div className="text-xs bg-purple-100 text-purple-800 px-3 py-1 rounded-full whitespace-nowrap">
                  {incompleteFields} details incomplete
                </div>
              </div>

              {/* Progress Bar */}
              <div className="h-2 bg-purple-200 rounded-full overflow-hidden mt-2">
                <div
                  className="bg-purple-600 h-full transition-all duration-300"
                  style={{ width: `${completionPercent}%` }}
                ></div>
              </div>
            </div>
            {/* Yellow Capsule Buttons*/}
            <div className="grid grid-cols-2 gap-3">
              {(!siteData?.description ||
                siteData.description.trim() === "") && (
                  <button
                    onClick={() => setEditModalOpen(true)}
                    className="bg-[#FFEFC9] text-[#4D3400] px-4 py-2 text-sm rounded-full flex items-center justify-between gap-2 shadow-sm hover:shadow-md transition"
                  >
                    Add Project Overview{" "}
                    <span className="text-xl font-bold">＋</span>
                  </button>
                )}

              {(!siteData?.esrimated_cost || siteData.esrimated_cost === 0) && (
                <button
                  onClick={() => setEditModalOpen(true)}
                  className="bg-[#FFEFC9] text-[#4D3400] px-4 py-2 text-sm rounded-full flex items-center justify-between gap-2 shadow-sm hover:shadow-md transition"
                >
                  Add Estimate Budget{" "}
                  <span className="text-xl font-bold">＋</span>
                </button>
              )}

              {(!siteData?.address || siteData.address.trim() === "") && (
                <button
                  onClick={() => setEditModalOpen(true)}
                  className="bg-[#FFEFC9] text-[#4D3400] px-4 py-2 text-sm rounded-full flex items-center justify-between gap-2 shadow-sm hover:shadow-md transition"
                >
                  Add Site Address <span className="text-xl font-bold">＋</span>
                </button>
              )}

              {(!siteData?.site_area || siteData.site_area === 0) && (
                <button
                  onClick={() => setEditModalOpen(true)}
                  className="bg-[#FFEFC9] text-[#4D3400] px-4 py-2 text-sm rounded-full flex items-center justify-between gap-2 shadow-sm hover:shadow-md transition"
                >
                  Add Site Area <span className="text-xl font-bold">＋</span>
                </button>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
        {/* LEFT SIDE */}
        <div className="flex flex-col gap-4 border-b">
          {/* Image */}
          <div
            className="h-48 bg-cover bg-center rounded-lg w-full"
            style={{
              backgroundImage: siteData?.image_file
                ? `url(${siteData.image_file})`
                : "url(https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2831&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)",
            }}
          >
            <div className="flex justify-end p-2">
              <input
                type="file"
                accept="image/*"
                className="hidden"
                id="site-image-upload"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleUpdate("image_file", file);
                  }
                }}
              />
              <label
                htmlFor="site-image-upload"
                className="bg-white p-2 rounded-full shadow-md cursor-pointer hover:bg-gray-100 transition"
              >
                <Pencil size={16} className="text-gray-600" />
              </label>
            </div>
          </div>
          <div
            onClick={() => setEditModalOpen(true)}
            className="bg-white p-4 rounded-lg shadow-sm cursor-pointer hover:shadow-md transition"
          >
            <p className="text-md text-gray-900 mb-1">Project Overview</p>
            <p className="text-gray-500 text-sm">
              {siteData?.description?.trim()
                ? siteData.description
                : "Write a description for this project"}
            </p>
          </div>

          {/* Site Address */}
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <p className="text-sm text-gray-500 mb-1">Site Address</p>
            <div className="text-gray-800 text-sm flex justify-between items-center">
              <span>
                {siteData?.address
                  ? `${siteData.address +
                  ", " +
                  siteData?.city +
                  ", " +
                  siteData?.state +
                  " " +
                  siteData?.pincode
                  }`
                  : "—"}
              </span>
              <button
                disabled={!editPermsission}
                onClick={() => setEditModalOpen(true)}
                className="text-purple-600"
              >
                <ChevronRight className="text-gray-400 w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="flex flex-col gap-4">
          {/* Start Date */}
          <button
            onClick={() => setEditModalOpen(true)}
            className="text-left bg-white p-4 rounded-lg shadow-sm w-full hover:shadow-md transition flex justify-between items-center"
          >
            <div>
              <p className="text-sm text-gray-500 mb-1">Start Date</p>
              <p className="font-medium text-gray-900">
                {siteData?.start_date || "—"}
              </p>
            </div>
            <ChevronRight className="text-gray-400 w-4 h-4" />
          </button>
          <button
            onClick={() => setEditModalOpen(true)}
            className="text-left bg-white p-4 rounded-lg shadow-sm w-full hover:shadow-md transition flex justify-between items-center"
          >
            <div>
              <p className="text-sm text-gray-500 mb-1">Site Area</p>
              <p className="font-medium text-gray-900">
                {siteData?.site_area} {siteData?.uom}
              </p>
            </div>
            <ChevronRight className="text-gray-400 w-4 h-4" />
          </button>

          {/* Estimate Budget */}
          <button
            onClick={() => setEditModalOpen(true)}
            className="text-left bg-white p-4 rounded-lg shadow-sm w-full hover:shadow-md transition flex justify-between items-center"
          >
            <div>
              <p className="text-sm text-gray-500 mb-1">Estimate Budget</p>
              <p className="font-medium text-gray-900">
                ₹{siteData?.esrimated_cost || "—"}
              </p>
            </div>
            <ChevronRight className="text-gray-400 w-4 h-4" />
          </button>

          <button
            onClick={() => setEditModalOpen(true)}
            className="text-left bg-white p-4 rounded-lg shadow-sm w-full hover:shadow-md transition flex justify-between items-center"
          >
            <div>
              <p className="text-sm text-gray-500 mb-1">Building Category</p>
              <p className="font-medium text-gray-900">
                {categories.find((cat) => cat.id === siteData?.site_catagory_id)
                  ?.catagory_name || "—"}
              </p>
            </div>
            <ChevronRight className="text-gray-400 w-4 h-4" />
          </button>

          <button
            onClick={() => setEditModalOpen(true)}
            className="text-left bg-white p-4 rounded-lg shadow-sm w-full hover:shadow-md transition flex justify-between items-center"
          >
            <div>
              <p className="text-sm text-gray-500 mb-1">Administrative Body</p>
              <p className="font-medium text-gray-900">
                {siteData?.local_admin_body_name}
              </p>
            </div>
            <ChevronRight className="text-gray-400 w-4 h-4" />
          </button>
        </div>
      </div>

      {editModalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div
            className="relative w-full max-w-2xl bg-white rounded-xl p-6 shadow-lg max-h-[90vh] overflow-y-scroll"
            style={{
              scrollbarWidth: "none",
            }}
          >
            {/* Close button */}
            <button
              onClick={() => setEditModalOpen(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <X size={24} />
            </button>

            <h2 className="text-xl font-semibold text-center mb-6">
              Edit Details
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Project Name */}
              <div>
                <label className="text-sm text-gray-600">Project Name</label>
                <input
                  type="text"
                  value={formData.site_name}
                  onChange={(e) =>
                    setFormData({ ...formData, site_name: e.target.value })
                  }
                  className="w-full mt-1 p-2 border border-gray-300 rounded"
                />
              </div>

              {/* Start Date */}
              <div>
                <label className="text-sm text-gray-600">Start Date</label>
                <input
                  type="date"
                  value={formData.start_date}
                  onChange={(e) =>
                    setFormData({ ...formData, start_date: e.target.value })
                  }
                  className="w-full mt-1 p-2 border border-gray-300 rounded"
                />
              </div>

              {/* Project Overview */}
              <div className="col-span-2">
                <label className="text-sm text-gray-600">
                  Project Overview
                </label>
                <textarea
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  rows={3}
                  className="w-full mt-1 p-2 border border-gray-300 rounded"
                />
              </div>

              {/* Site Address Section */}
              <div className="col-span-2">
                <label className="text-sm text-gray-600 mb-2 block">
                  Site Address
                </label>

                {/* Address Line  */}
                <input
                  type="text"
                  value={formData.address || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, address: e.target.value })
                  }
                  placeholder="Street address"
                  className="w-full mb-3 p-2 border border-gray-300 rounded"
                />

                {/* Address Line 2 */}
                {/* <input
                  type="text"
                  value={formData.addressLine2 || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, addressLine2: e.target.value })
                  }
                  placeholder="Address line 2"
                  className="w-full mb-3 p-2 border border-gray-300 rounded"
                /> */}

                {/* City and State dropdowns */}
                <div className="flex gap-4">
                  <div className="w-1/3">
                    <label className="text-sm text-gray-600 mb-1 block">
                      State
                    </label>
                    <select
                      value={formData.state || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          state: e.target.value,
                          city: "",
                        })
                      }
                      className="w-full p-2 border border-gray-300 rounded"
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="w-1/3">
                    <label className="text-sm text-gray-600 mb-1 block">
                      City
                    </label>
                    <select
                      value={formData.city || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, city: e.target.value })
                      }
                      className="w-full p-2 border border-gray-300 rounded"
                    >
                      <option value="">Select City</option>
                      {cities.map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="w-1/3">
                    <label className="text-sm text-gray-600 mb-1 block">
                      Pincode
                    </label>
                    <input
                      type="text"
                      value={formData.pincode || ""}
                      onChange={(e) => {
                        const val = (e.target.value || "")
                          .replace(/\D/g, "")
                          .slice(0, 6); // only digits, max 6
                        setFormData({ ...formData, pincode: val });
                        if (val.length === 6) handlePinChange(val); // fetch only when valid 6-digit PIN
                      }}
                      placeholder="Pincode"
                      className="w-full mb-3 p-2 border border-gray-300 rounded"
                    />
                  </div>
                </div>
              </div>

              {/* Category */}
              <div>
                <label className="text-sm text-gray-600">
                  Building Category
                </label>
                <select
                  value={formData.site_catagory_id}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      site_catagory_id: e.target.value,
                    })
                  }
                  className="w-full mt-1 p-2 border border-gray-300 rounded"
                >
                  <option value="">Select</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.catagory_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Admin Body */}
              <div>
                <label className="text-sm text-gray-600">
                  Administrative Body
                </label>
                <select
                  value={formData.local_admin_body_id}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedName =
                      adminBodies.find((ab) => ab.id === parseInt(selectedId))
                        ?.admin_body_type || "";
                    setFormData({
                      ...formData,
                      local_admin_body_id: selectedId,
                      local_admin_body_name: selectedName,
                    });
                  }}
                  className="w-full mt-1 p-2 border border-gray-300 rounded"
                >
                  <option value="">Select</option>
                  {adminBodies.map((body) => (
                    <option key={body.id} value={body.id}>
                      {body.admin_body_type}
                    </option>
                  ))}
                </select>
              </div>

              {/* Estimate Budget */}
              <div>
                <label className="text-sm text-gray-600">Estimate Budget</label>
                <input
                  type="number"
                  value={formData.esrimated_cost}
                  onChange={(e) =>
                    setFormData({ ...formData, esrimated_cost: e.target.value })
                  }
                  className="w-full mt-1 p-2 border border-gray-300 rounded"
                />
              </div>

              {/* Site Area & Unit */}
              <div className="flex gap-2">
                <div className="flex-1">
                  <label className="text-sm text-gray-600">Site Area</label>
                  <input
                    type="number"
                    value={formData.site_area}
                    onChange={(e) =>
                      setFormData({ ...formData, site_area: e.target.value })
                    }
                    className="w-full mt-1 p-2 border border-gray-300 rounded"
                  />
                </div>
                <div>
                  <label className="text-sm text-gray-600">Unit</label>
                  <select
                    value={formData.site_unit}
                    onChange={(e) =>
                      setFormData({ ...formData, site_unit: e.target.value })
                    }
                    className="w-full mt-1 p-2 border border-gray-300 rounded"
                  >
                    <option value="m_sq">Sq. Meter</option>
                    <option value="ft_sq">Sq. Ft.</option>
                    <option value="acre">Acre</option>
                    <option value="hectare">Hectare</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Update Button */}
            <div className="text-center mt-6 flex flex-row items-center justify-center">
              <button
                onClick={async () => {
                  const siteId = localStorage.getItem("site");
                  const token = localStorage.getItem("access");

                  // Build a safe payload: map fields, coerce numerics, and drop empty strings
                  const cleaned = {
                    ...formData,
                    // Map UI field to API field
                    uom: formData.site_unit || undefined,
                    // Numeric coercions (blank -> null)
                    esrimated_cost:
                      formData.esrimated_cost === "" ||
                        formData.esrimated_cost === null
                        ? null
                        : Number(formData.esrimated_cost),
                    site_area:
                      formData.site_area === "" || formData.site_area === null
                        ? null
                        : Number(formData.site_area),
                    pincode:
                      formData.pincode === "" || formData.pincode === null
                        ? null
                        : String(formData.pincode).length === 6
                          ? Number(formData.pincode)
                          : undefined, // if not valid length, omit
                    // Coerce FK IDs to numbers when present
                    site_catagory_id:
                      formData.site_catagory_id === "" ||
                        formData.site_catagory_id === null
                        ? undefined
                        : Number(formData.site_catagory_id),
                    local_admin_body_id:
                      formData.local_admin_body_id === "" ||
                        formData.local_admin_body_id === null
                        ? undefined
                        : Number(formData.local_admin_body_id),
                  };

                  // Remove keys with empty string or undefined values
                  const updatedPayload = Object.fromEntries(
                    Object.entries(cleaned).filter(
                      ([, v]) => v !== "" && v !== undefined
                    )
                  );
                  // Do not send UI-only key
                  delete updatedPayload.site_unit;
                  try {
                    await axios.patch(
                      `${BASE_URL}/sites/update-sites/${siteId}/`,
                      updatedPayload,
                      { headers: { Authorization: `Bearer ${token}` } }
                    );
                    fetchSiteDetails(); // refresh
                    setEditModalOpen(false);
                    addAlert("Site details updated successfully", "success");
                  } catch (err) {
                    console.error("Error updating details:", err);
                  }
                }}
                className="bg-[#3B0069] hover:bg-[#3B0069D6] text-white rounded-xl px-3 py-2 flex flex-col items-center justify-center"
              >
                Update Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteConfirmOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
            <h3 className="text-lg font-semibold mb-4">Confirm deletion</h3>
            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to delete this site? This action cannot be
              undone.
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setDeleteConfirmOpen(false)}
                className="px-4 py-2 rounded bg-gray-100"
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteSite}
                disabled={deleting}
                className="px-4 py-2 rounded bg-red-600 text-white"
              >
                {deleting ? "Deleting..." : "Delete Site"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default SiteDetails;